<div class="currency">
    
    <div class="d-flex align-items-center">
        <h3>{{ currency.languageIsoCode }}-{{ currency.countryCode }}</h3> 
        <h3>&ensp;({{ currency.currencyCode }})</h3>
    </div>
    <price-preview [format]="currency"></price-preview>
</div>
